import userApi from './user/userApi.js'

export default {userApi}